export default function capitalizeFirstLetter(message: string): string {
  return message[0].toUpperCase() + message.slice(1);
}
